<form (ngSubmit)="onSubmit()" class="form is-flex has-flex-align-center" [ngClass]="ListingCategory[currentShownListingType]" [formGroup]="filtersForm" #form>
  <div class="pseudo-dropdown property-types-dd">
    <a class="has-pos-rel select-wrapper is-flex" (click)="closeDropdowns('showBusinessTypes', !showBusinessTypes)">
      {{businessText}}
      <i class="material-icons dropdown-caret">{{ showBusinessTypes ? 'keyboard_arrow_up' : 'keyboard_arrow_down'}}</i>
    </a>
    <div class="dropdown-content business-types-dd" *ngIf="showBusinessTypes">
      <app-switch [allowUncheck]="false" [checked]="showAllBusinessTypes" label="{{ 'filters.all' | translate }}" (checkedChange)="clearBusinessTypes()"
                  style="margin-top: 10px;" inputId="input-switch-all"></app-switch>
      <fieldset [formGroup]="businessTypesFg">
        <app-checkbox *ngFor='let item of businessType' [text]="item"
                      [formControl]="businessTypesFg.get(item)" [parentFormGroup]="businessTypesFg"></app-checkbox>
      </fieldset>
    </div>
  </div>

  <div class="pseudo-dropdown property-types-dd">
    <a class="has-pos-rel select-wrapper is-flex" (click)="closeDropdowns('showListingTypes', !showListingTypes)">
      {{propertyText}}
      <i class="material-icons dropdown-caret">{{ showListingTypes ? 'keyboard_arrow_up' : 'keyboard_arrow_down'}}</i>
    </a>
    <div class="dropdown-content" *ngIf="showListingTypes">
      <app-switch [allowUncheck]="false" [checked]="showAllListingTypes" label="{{ 'filters.all' | translate }}" (checkedChange)="clearListingTypes()"
                  style="margin-top: 10px;" inputId="input-switch-all"></app-switch>
      <fieldset [formGroup]="listingTypesFg">
        <app-checkbox *ngFor='let item of listingType' [text]="('filters.listing-type.' + item) | translate"
                      [formControl]="listingTypesFg.get(item)" [parentFormGroup]="listingTypesFg"></app-checkbox>
      </fieldset>
    </div>
  </div>

  <div class="pseudo-dropdown price-dd">
    <a class="has-pos-rel select-wrapper is-flex" (click)="closeDropdowns('showPrice', !showPrice)">
      {{priceText}}
      <i class="material-icons dropdown-caret">{{ showPrice ? 'keyboard_arrow_up' : 'keyboard_arrow_down'}}</i>
    </a>
    <div class="dropdown-content is-flex is-flex-column has-flex-content-space-around" *ngIf="showPrice">
      <div>
        <app-select [options]="priceOptions" [formControl]="filtersForm.controls['priceType']" [parentFormGroup]="filtersForm"></app-select>
      </div>
      <div class="is-flex" style="margin-top: 10px">
        <app-select class="flex-one" style="margin-right: 10px" [parentFormGroup]="filtersForm" [formControl]="filtersForm.get('minPrice')" [options]="isPricePerSqft ? minSqftPriceOptions : minPriceOptions"></app-select>
        <app-select class="flex-one" [parentFormGroup]="filtersForm" [formControl]="filtersForm.get('maxPrice')" [options]="isPricePerSqft ? maxSqftPriceOptions : maxPriceOptions"></app-select>
      </div>
    </div>
  </div>

  <div class="pseudo-dropdown more-dd">
    <a (click)="closeDropdowns('showMore', !showMore)" class="has-pos-rel select-wrapper is-flex">
      {{moreText}}
      <i class="material-icons dropdown-caret">{{ showMore ? 'keyboard_arrow_up' : 'keyboard_arrow_down'}}</i>
    </a>
    <div class="dropdown-content" *ngIf="showMore">

      <app-select [options]="sqftOptions" [compareWith]="compareWithHasMinMax"
                  [formControl]="filtersForm.get('size')" [parentFormGroup]="filtersForm"></app-select>

      <app-select [options]="storiesOptions" [compareWith]="compareWithHasMinMax"
                  [formControl]="filtersForm.get('stories')" [parentFormGroup]="filtersForm"></app-select>

      <app-select [options]="unitsOptions" [compareWith]="compareWithHasMinMax"
                  [formControl]="filtersForm.get('units')" [parentFormGroup]="filtersForm"></app-select>

      <app-select [options]="totalAcresOptions" [compareWith]="compareWithHasMinMax"
                  [formControl]="filtersForm.get('totalAcres')" [parentFormGroup]="filtersForm"></app-select>

      <app-select [options]="parkingOptions" [compareWith]="compareWithHasMinMax"
                  [formControl]="filtersForm.get('parking')" [parentFormGroup]="filtersForm"></app-select>
      <app-select id="desktopFilters-select-updatedSince" label="Updated Since" [options]="updatedSinceOptions" class="updatedSince-select"
                  [formControl]="filtersForm.get('updatedSince')" [parentFormGroup]="filtersForm"></app-select>
      <hr/>
      <button class="btn btn-secondary btn-full-sized" role="button" translate="filters.apply"></button>
    </div>
  </div>

  <button class="btn btn-fake reset reset-commercial-filters" (click)="onReset()">
    <svg width="16px" height="15px" viewBox="0 0 16 15" version="1.1" xmlns="http://www.w3.org/2000/svg">
      <g transform="translate(-116 -923)" fill="none" fill-rule="evenodd">
        <g transform="translate(116.76 923.66)" fill="#004E9B">
          <path d="m5.3577 5.5705c0-0.31292-0.25769-0.56568-0.57692-0.56568l-2.5577 0.007946c0.73846-2.2438 2.8962-3.8054 5.3077-3.8129h0.019231c2.6923 0 5.0077 1.8855 5.5038 4.4895 0.05 0.27281 0.29231 0.46351 0.56538 0.46351 0.034615 0 0.073077-0.0034054 0.10769-0.0098378 0.31154-0.057892 0.51923-0.35416 0.46154-0.66254-0.6-3.1413-3.3885-5.4157-6.6385-5.4157h-0.023077c-2.6692 0.0083243-5.0846 1.5998-6.15 3.9571l-0.0076923-2.128c0-0.31254-0.26154-0.56568-0.57692-0.56568h-0.0038462c-0.31538 0.0011351-0.57308 0.25616-0.57308 0.56946l0.011538 3.6892c0 0.15059 0.061538 0.29476 0.16923 0.4007s0.25385 0.16497 0.40769 0.16497l3.9808-0.012486c0.31923-0.0011351 0.57692-0.25616 0.57308-0.56946"/>
          <path d="m14.858 8.1223c-0.0038461-0.31254-0.26154-0.56568-0.57692-0.56568h-0.0038461l-3.9769 0.012486c-0.31923 0.0011351-0.57692 0.25616-0.57692 0.56946 0.0038462 0.31292 0.26154 0.56568 0.57692 0.56568h0.0038462l2.5962-0.007946c-0.70769 2.3002-2.8692 3.8943-5.3346 3.9022h-0.015385c-2.4231 0-4.8769-1.8756-5.3654-4.1024-0.069231-0.30686-0.37692-0.50059-0.68462-0.43551-0.31154 0.066216-0.51154 0.36816-0.44231 0.67427 0.60385 2.7599 3.5154 4.9988 6.4923 4.9988h0.019231c2.6846-0.0087027 5.0692-1.5722 6.1385-3.9143l0.0076923 1.9959c0 0.31254 0.25769 0.56568 0.57692 0.56568 0.31923-0.0011351 0.57692-0.25616 0.57692-0.56946l-0.011538-3.6892"/>
        </g>
      </g>
    </svg>
    {{ 'filters.reset' | translate }}
  </button>
</form>
